import React from "react";
import styled from "styled-components";
import { size } from "utils/device";
import { Overlay, Popover } from "react-bootstrap";

const messages = [
  { message: "At least 8 characters with max being 32", regex: /^.{8,32}$/ },
  { message: "Cannot start with a number ", regex: /^[^0-9]/ },
  { message: "At least one digit", regex: /[0-9]/ },
  { message: "At least one special character", regex: /[!@#$&*]/ },
  { message: "At least one Uppercase required", regex: /[A-Z]/ },
];

const PasswordPopover = ({ show, target, reference, value }) => {
  const isMobile = window.innerWidth < size.tablet;
  return (
    <Overlay
      show={show}
      target={target}
      placement={isMobile ? "bottom" : "right"}
      container={reference}
      containerPadding={20}
    >
      <Popover id="popover-contained">
        <Popover.Title as="h3">Your password must have:</Popover.Title>
        <Popover.Content>
          <ul>
            {messages.map(({ message, regex }, index) => (
              <li key={index}>
                {value && regex.test(value) ? (
                  <Valid>{message}</Valid>
                ) : (
                  <Invalid>{message}</Invalid>
                )}
              </li>
            ))}
          </ul>
        </Popover.Content>
      </Popover>
    </Overlay>
  );
};

const Valid = styled.span`
  color: green;
`;

const Invalid = styled.span`
  color: red;
`;

export default PasswordPopover;
